// import * as angular from 'angular';

export function CapitalizePipe() {
  return function (input) {
    if (input) {
      var words = [];

      words = input.indexOf('_') !== -1 ? input.split('_') : input.split(' ');

      angular.forEach(words, function (word, index) {
        words[index] = word.charAt(0).toUpperCase() + word.substring(1, word.length);
      });

      return words.join(' ');
    }
  };
}
